import { gql } from '@apollo/client';

import { CUSTOM_PACING_LINE_ITEM_ERROR } from '../fragments/customPacingLineItemError';
import { PACING_METRICS } from '../fragments/pacingMetrics';
import { WINDOW_PACING_METRICS } from '../fragments/windowPacingMetrics';

export const CALCULATE_CUSTOM_PACING_METRICS = gql`
  query calculateCustomPacingMetrics($customPacing: CustomPacingInput!, $lineItemIdList: [String!]) {
    calculateCustomPacingMetrics(input: { customPacing: $customPacing, lineItemIdList: $lineItemIdList }) {
      summary {
        linesScheduled
        preSchedule {
          ...pacingMetrics
        }
        postSchedule {
          ...pacingMetrics
        }
        windows {
          ...windowPacingMetrics
        }
        trueEstimatedWindowsShift
        differenceOverStraightlineDaily
      }
      lineItemList {
        id
        advertiserName
        OMSPackageName
        opportunityOrderType
        name
        tier
        priority
        startDate
        endDate
        delivered
        deliveryGoal
        preSchedule {
          ...pacingMetrics
        }
        postSchedule {
          ...pacingMetrics
        }
        windows {
          ...windowPacingMetrics
        }
        moveForwardDeliveryGoal
        trueEstimatedWindowsShift
        differenceOverStraightlineDaily
      }
      errorList {
        ...customPacingLineItemError
      }
    }
  }
  ${PACING_METRICS}
  ${WINDOW_PACING_METRICS}
  ${CUSTOM_PACING_LINE_ITEM_ERROR}
`;
